import { useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { toast } from 'react-toastify'

export function useFlashToast() {
  const { flash } = usePage().props

  useEffect(() => {
    if (flash?.notice) toast.success(flash.notice)
    if (flash?.alert)  toast.error(flash.alert)
  }, [flash])
}
